module.exports = __webpack_public_path__ + "media/images/font/flaticon-91f50906b333d6eb5a8ed9db789d055c.woff2";